module.exports = __webpack_public_path__ + "img/logo-STAIKA.c856a8d4.svg";